import { usePageCtas } from '~/modules/enquiry/component/PageCtasProvider';
import { useScrolledPast } from '~/ui-rocco/pages/detail-shared';

/** Page depth from which the desktop island's enquiry fallback may appear. */
export const ISLAND_ENQUIRY_CLAIM_FRACTION = 0.3;

/** Page depth past which the nav claims yield the island to the enquiry pill. */
export const ISLAND_ENQUIRY_TAKEOVER_FRACTION = 0.5;

/**
 * True once the desktop island belongs to the enquiry fallback: the reader is
 * past half-scroll AND the page's Enquire button shows. The nav
 * claims (About-the-Supplier carousel, Range / Similar Products links) gate on
 * this so they only yield when an enquiry pill exists to take over — with the
 * button hidden they keep the island for the whole page.
 */
export const useEnquiryOwnsIsland = (): boolean => {
    const { ctas } = usePageCtas();
    const pastTakeover = useScrolledPast(ISLAND_ENQUIRY_TAKEOVER_FRACTION);
    return pastTakeover && ctas.enquire.visible;
};
